import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAccountRequest } from "../../../http/requests/account.http";
import { setReverseDomainMode } from "../../../core/constants/admissionDomainConfig";

export const fetchGetAccount = createAsyncThunk("account/user", async () => {
  const response = await getAccountRequest();

  if (!response.data.error && response.data.payload) {
    setReverseDomainMode(response.data.payload.reverse);
  }

  return response.data;
});
